import { API } from 'aws-amplify';

export const callLLMMultiVisit = async (prompt: string, mrn: string, csn: string, encounter_types: string[], session_id: string, message_id: string): Promise<string> => {
    const input = {
        prompt: prompt,
        mrn: mrn,
        csn: csn,
        encounter_types: encounter_types,
        session_id: session_id,
        message_id: message_id,
    };

    try {
        const response: any = await API.post("EDPlatformLLMAPI", "/multivisit", {
            body: input,
        });
        console.log('callLLMMultiVisit response', response);
        return response;
    } catch (err: any) {
        console.error(err)
        console.log("Error when calling callLLMMultiVisit");
        return "";
    }
}
